import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, ClockIcon, ActivityIcon, CalendarIcon } from 'lucide-react';
export function TreatmentTimeline() {
  const columns = [{
    icon: ClipboardCheckIcon,
    title: 'Before Treatment',
    items: ['Complete consent and medical history forms', 'Health assessment and pain / range-of-motion evaluation', 'Wear provided safety goggles', 'Remove jewelry from the treatment area if needed']
  }, {
    icon: ClockIcon,
    title: 'During Treatment',
    items: ['Most sessions are quick, often around 3 to 12 minutes depending on the area', 'Treatment is typically painless and non-invasive', 'Many patients notice a soothing, gentle warmth', 'The handpiece is used directly on the skin or slightly above it', 'The provider may reassess pain and range of motion during the session']
  }, {
    icon: ActivityIcon,
    title: 'After Treatment',
    items: ['Some patients feel relief right away; others later the same day or next day', 'Hydration is highly encouraged to support cellular flush', 'Avoid heavy overexertion for 24 to 48 hours', 'Track how long symptom relief and improved movement last', 'Follow the recommended treatment plan for best cumulative results']
  }];
  return <section className="py-20 md:py-28 bg-brand-gray-light" data-id="element-255">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-257">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-6" data-id="element-258">
            What to Expect From Treatment
          </h2>
          <p className="text-lg text-gray-600" data-id="element-259">
            Laser therapy is a comfortable, straightforward process. Here is
            what a typical patient journey looks like from start to finish.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-260">
          {/* Desktop Timeline Connector */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-teal/20 z-0" data-id="element-261" />

          {columns.map((col, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 relative z-10" data-id="element-262">
              <div className="w-16 h-16 mx-auto bg-brand-teal text-white rounded-full flex items-center justify-center mb-6 shadow-lg shadow-brand-teal/20 ring-4 ring-white" data-id="element-263">
                <col.icon className="w-8 h-8" data-id="element-264" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy text-center mb-6" data-id="element-265">
                {col.title}
              </h3>
              <ul className="space-y-4" data-id="element-266">
                {col.items.map((item, itemIdx) => <li key={itemIdx} className="flex items-start gap-3 text-gray-600" data-id="element-267">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-teal mt-2 flex-shrink-0" data-id="element-268" />
                    <span className="leading-relaxed text-sm lg:text-base" data-id="element-269">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-270">
          <button className="px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-semibold text-lg transition-all duration-300 inline-flex items-center justify-center gap-2 shadow-lg shadow-brand-teal/25" data-id="element-271">
            <CalendarIcon className="w-5 h-5" data-id="element-272" />
            Schedule Your First Session
          </button>
        </motion.div>
      </div>
    </section>;
}